export const configurationsConstants = {
  GET_SMARTPHONE_DEVICES: "GET_SMARTPHONE_DEVICES",
  GET_POSTAL_CODES: "GET_POSTAL_CODES",
  TEXTAREA_INPUT_LENGTH: 2000,
  EMAIL_INPUT_LENGTH: 45,
  PASSWORD_INPUT_LENGTH: 50,
};
